export default __webpack_public_path__ + "f81a96425580801d1293166adfe1e064.png";